import { Currency } from "@lookiero/sty-psp-locale";
import { CurrencyAndCategories } from "../../../domain/projections/Category";

interface CategoriesDTO {
  readonly currency: string;
  readonly categories: {
    readonly id: string;
    readonly productVariants: {
      readonly id: string;
      readonly brand: string;
      readonly images: {
        readonly featured: string;
        readonly standard: string;
        readonly detail: string;
      };
      readonly price: number;
      readonly discountedPrice: number;
      readonly discountedPercentage: number;
      readonly title: string;
    }[];
  }[];
}

const mapCategoriesDTOtoCurrencyAndCategories = (categoriesDTO: CategoriesDTO): CurrencyAndCategories => {
  return {
    currency: categoriesDTO.currency as Currency,
    categories: categoriesDTO.categories.map((category) => ({
      id: category.id,
      products: category.productVariants.map((productDto) => ({
        id: productDto.id,
        brand: productDto.brand,
        images: {
          featured: productDto.images.featured,
          standard: productDto.images.standard,
          detail: productDto.images.detail,
        },
        price: {
          amount: productDto.price,
          currency: categoriesDTO.currency as Currency,
          discountedPrice: {
            amount: productDto.discountedPrice,
            percentage: productDto.discountedPercentage,
          },
        },
        title: productDto.title,
      })),
    })),
  };
};

export type { CategoriesDTO };
export { mapCategoriesDTOtoCurrencyAndCategories };
